import { OverseaBridge } from '@/static/hook/useBridge';

/**
 * @description: 生成桥的实例的函数，需要在合适的渲染阶段调用
 * @return: ksbridge函数
 */

const getKsBridge = async () => {
  //@ts-ignore
  const ksBridge = (await import('@ks/ks-bridge').then((mod) => mod.default)) as OverseaBridge;
  ksBridge.config({
    //debug: true, /* 调试开关 */
    name: 'Kwai',
  });

  ksBridge.register('getAvailableShareThirdPlatforms', 'getAvailableShareThirdPlatforms', 'oversea');
  ksBridge.register('directShare', 'directShare', 'oversea');
  ksBridge.register('initIAP', 'initIAP', 'oversea');
  ksBridge.register('getProductLocalCurrencyAndPrice', 'getProductLocalCurrencyAndPrice', 'oversea');
  ksBridge.register('launchIAP', 'launchIAP', 'oversea');
  ksBridge.register('selectShare', 'selectShare', 'oversea');
  ksBridge.register('mercuryShare', 'mercuryShare', 'oversea');
  ksBridge.register('popBack', 'popBack', 'oversea');
  ksBridge.register('loadUrlOnNewPage', 'loadUrlOnNewPage', 'oversea');
  ksBridge.register('startOperationActivity', 'startOperationActivity', 'oversea');
  ksBridge.register('startCountdownTask', 'startCountdownTask', 'oversea');
  ksBridge.register('reLogin', 'reLogin', 'oversea');
  ksBridge.register('preDownloadMagicFace', 'preDownloadMagicFace', 'oversea');
  ksBridge.register('preDownloadMv', 'preDownloadMv', 'oversea');
  ksBridge.register('isPlatformAvailableInDevice', 'isPlatformAvailableInDevice', 'oversea');
  ksBridge.register('openLive', 'openLive', 'oversea');
  ksBridge.register('pasteboard', 'pasteboard', 'oversea');
  return ksBridge;
};

export default getKsBridge;
